import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import Softscape from "../../components/softscape/Softscape";

function SoftscapePage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Softscape | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"Softscape"} t={t} />
      <Softscape />
    </>
  );
}

export default SoftscapePage;
